(function(){
  'use strict';

  function ready(fn){
    if(document.readyState==='loading'){
      document.addEventListener('DOMContentLoaded',fn,{once:true});
    }else{
      fn();
    }
  }

  ready(function(){
    var root=document.querySelector('.ap-page');
    if(!root||root.dataset.resetSalesReadiness==='true'){return;}
    root.dataset.resetSalesReadiness='true';

    var pathMatch=window.location.pathname.match(/\/products\/([^\/?#]+)/i);
    if(!pathMatch){return;}
    var handle=String(pathMatch[1]||'').toLowerCase();

    var rules={
      'airpods-2nd-gen-replacement-parts':{
        left:{models:['a2031']},right:{models:['a2032']},case:{models:['a1602']},wireless:{models:['a1938'],hideMissing:true},whole:{set:true}
      },
      'airpods-3rd-generation':{
        left:{models:['a2564']},right:{models:['a2565']},case:{models:['a2566']},whole:{set:true}
      },
      'airpods-pro-1st-generation':{
        left:{models:['a2084']},right:{models:['a2083']},case:{models:['a2190']},whole:{set:true}
      },
      'airpods-pro-2nd-generation':{
        left:{models:['a2699','a3048'],exactWhenSingle:true},right:{models:['a2698','a3047'],exactWhenSingle:true},case:{models:['a2700','a2968'],exactWhenSingle:true},whole:{set:true,exactWhenSingle:true}
      },
      'airpods-4-replacement-part':{
        left:{models:['a3053']},right:{models:['a3050']},case:{models:['a3058']},'anc-left':{models:['a3056']},'anc-right':{models:['a3055']},'anc-case':{models:['a3059']},whole:{set:true,exactWhenSingle:true}
      },
      'airpods-pro-3-replacement':{
        left:{models:['a3064']},right:{models:['a3063']},case:{models:['a3122']},whole:{set:true}
      }
    };

    var config=rules[handle];
    if(!config){return;}

    var productVariants=[];
    var patchQueued=false;

    function normalise(value){
      return String(value||'').toLowerCase().replace(/[^a-z0-9]+/g,' ').trim();
    }

    function setText(element,value){
      if(element&&element.textContent!==value){element.textContent=value;}
    }

    function option(part){
      return root.querySelector('.ap-option[data-part="'+part+'"]');
    }

    function patchOption(part,title,model,match,label){
      var button=option(part);
      if(!button){return;}
      if(match){button.setAttribute('data-match',match);}
      if(label){button.setAttribute('data-label',label);}
      var titleEl=button.querySelector('span');
      var smallEl=button.querySelector('small');
      if(title){setText(titleEl,title);}
      if(model){
        if(!smallEl){smallEl=document.createElement('small');button.appendChild(smallEl);}
        setText(smallEl,model);
      }
    }

    function patchModelRow(label,newLabel,newModel){
      root.querySelectorAll('.ap-compatibility .ap-models > div').forEach(function(row){
        var span=row.querySelector('span');
        var strong=row.querySelector('strong');
        if(span&&normalise(span.textContent)===normalise(label)){
          setText(span,newLabel);
          setText(strong,newModel);
        }
      });
    }

    function patchInfoText(from,to){
      root.querySelectorAll('.ap-info-points span').forEach(function(el){
        if(el.textContent.indexOf(from)!==-1){
          el.textContent=el.textContent.replace(from,to);
        }
      });
    }

    function patchStaticCopy(){
      if(handle==='airpods-2nd-gen-replacement-parts'){
        var wireless=option('wireless');
        if(wireless){wireless.style.display='none';}
      }

      if(handle==='airpods-3rd-generation'){
        patchOption('case','Charging Case','A2566','case|a2566|c','Charging Case A2566');
        patchModelRow('Lightning Case','Charging Case','A2566');
        patchInfoText('Lightning Charging Case A2897','Charging Case A2566');
      }

      if(handle==='airpods-pro-2nd-generation'){
        patchOption('left','Left','A2699 / A3048','left|a2699|a3048|l','Left A2699 / A3048');
        patchOption('right','Right','A2698 / A3047','right|a2698|a3047|r','Right A2698 / A3047');
        patchModelRow('USB-C Left','USB-C Left','A3048');
        patchModelRow('USB-C Right','USB-C Right','A3047');
        patchInfoText('USB-C: Left A3047, Right A3048, Case A2968','USB-C: Left A3048, Right A3047, Case A2968');
      }
    }

    function modelCodeFromTitle(title){
      var match=normalise(title).match(/\ba\d{4}\b/);
      return match?match[0].toUpperCase():'';
    }

    function connectionFromTitle(title){
      var text=normalise(title);
      if(text.indexOf('usb c')!==-1||text.indexOf('usbc')!==-1){return 'USB-C';}
      if(text.indexOf('lightning')!==-1){return 'Lightning';}
      if(text.indexOf('anc')!==-1){return 'ANC';}
      if(text.indexOf('standard')!==-1){return 'Standard';}
      return '';
    }

    function matchingVariants(rule){
      return productVariants.filter(function(variant){
        var text=normalise(variant.title);
        if(rule.models&&rule.models.length){
          var words=text.split(' ');
          return rule.models.some(function(model){return words.indexOf(model)!==-1;});
        }
        if(rule.set){return text.indexOf('whole set')!==-1||text.indexOf('full set')!==-1;}
        return false;
      });
    }

    function stockStatus(button,text){
      var status=button.querySelector('[data-reset-stock-status]');
      if(!status){
        status=document.createElement('small');
        status.setAttribute('data-reset-stock-status','true');
        button.appendChild(status);
      }
      setText(status,text);
    }

    function clearStockStatus(button){
      button.disabled=false;
      button.removeAttribute('aria-disabled');
      button.classList.remove('reset-sold-out','reset-needs-version');
      var status=button.querySelector('[data-reset-stock-status]');
      if(status){status.remove();}
    }

    function markSoldOut(button){
      if(!button){return;}
      button.disabled=true;
      button.setAttribute('aria-disabled','true');
      button.classList.add('reset-sold-out');
      stockStatus(button,'Sold out');
    }

    function markNeedsVersion(button){
      if(!button){return;}
      button.disabled=true;
      button.setAttribute('aria-disabled','true');
      button.classList.add('reset-needs-version');
      stockStatus(button,'Choose exact version first');
    }

    function applySingleVariantLabel(part,variant){
      var button=option(part);
      if(!button||!variant){return;}
      var model=modelCodeFromTitle(variant.title);
      var connection=connectionFromTitle(variant.title);
      var title=part==='left'?'Left':part==='right'?'Right':part==='case'?'Charging Case':'Whole Set';
      var detail=[connection,model].filter(Boolean).join(' · ');
      var matchTerms=[];
      if(model){matchTerms.push(model.toLowerCase());}
      if(!model){
        if(part==='whole'){matchTerms.push('whole','full','set');}
        if(connection){matchTerms.push(connection.toLowerCase());}
      }
      patchOption(part,title,detail,matchTerms.join('|'),title+(detail?' '+detail:''));
    }

    function applyAvailability(){
      Object.keys(config).forEach(function(part){
        var rule=config[part];
        var button=option(part);
        if(!button){return;}
        var candidates=matchingVariants(rule);
        var available=candidates.filter(function(variant){return !!variant.available;});

        if(!candidates.length&&rule.hideMissing){
          button.style.display='none';
          return;
        }

        if(part==='wireless'&&candidates.length){button.style.display='flex';}

        if(!available.length){
          markSoldOut(button);
          return;
        }

        if(rule.exactWhenSingle&&available.length===1){
          clearStockStatus(button);
          applySingleVariantLabel(part,available[0]);
          return;
        }

        if(rule.exactWhenSingle&&available.length>1){
          markNeedsVersion(button);
          return;
        }

        clearStockStatus(button);
      });

      var visibleOptions=Array.prototype.slice.call(root.querySelectorAll('.ap-option')).filter(function(button){
        return button.style.display!=='none';
      });
      var allSoldOut=visibleOptions.length>0&&visibleOptions.every(function(button){return button.disabled;});
      var existing=root.querySelector('[data-reset-all-sold-out]');
      if(allSoldOut&&!existing){
        var note=document.createElement('div');
        note.setAttribute('data-reset-all-sold-out','true');
        note.className='reset-all-sold-out';
        note.textContent='This model is currently sold out. Please check back soon.';
        var optionsWrap=root.querySelector('.ap-options-wrap');
        if(optionsWrap){optionsWrap.appendChild(note);}
      }else if(!allSoldOut&&existing){
        existing.remove();
      }

      patchFinderAvailability();
    }

    function finderSelectedName(){
      var selected=root.querySelector('#finder-selected-model-name');
      return selected?normalise(selected.textContent):'';
    }

    function patchFinderCopy(){
      if(handle==='airpods-2nd-gen-replacement-parts'){
        var selected2=finderSelectedName();
        if(selected2.indexOf('airpods 2')!==-1){
          root.querySelectorAll('#finder-part-grid button').forEach(function(button){
            var detail=button.querySelector('span');
            if(detail&&normalise(detail.textContent)==='a1938'){button.style.display='none';}
          });
        }
      }

      if(handle==='airpods-3rd-generation'){
        var selected3=finderSelectedName();
        if(selected3.indexOf('airpods 3')!==-1){
          root.querySelectorAll('#finder-part-grid button').forEach(function(button){
            var detail=button.querySelector('span');
            if(detail&&normalise(detail.textContent)==='a2897'){button.style.display='none';}
          });
        }
      }

      if(handle==='airpods-pro-2nd-generation'){
        var modelButton=root.querySelector('#finder-model-grid [data-finder-model="pro-2-usbc"]');
        if(modelButton){
          modelButton.querySelectorAll('span,small').forEach(function(el){
            if(el.textContent==='Left: A3047'){setText(el,'Left: A3048');}
            if(el.textContent==='Right: A3048'){setText(el,'Right: A3047');}
          });
        }

        var selectedName=finderSelectedName();
        if(selectedName.indexOf('usb c')!==-1){
          var partButtons=root.querySelectorAll('#finder-part-grid button');
          if(partButtons[0]){
            var leftDetail=partButtons[0].querySelector('span');
            if(leftDetail){setText(leftDetail,'A3048');}
          }
          if(partButtons[1]){
            var rightDetail=partButtons[1].querySelector('span');
            if(rightDetail){setText(rightDetail,'A3047');}
          }
          var summary=root.querySelector('#finder-selected-summary');
          if(summary){
            var fixed=summary.textContent.replace('Left: A3047','Left: A3048').replace('Right: A3048','Right: A3047');
            if(summary.textContent!==fixed){summary.textContent=fixed;}
          }
          var resultTitle=root.querySelector('#finder-result-title');
          var resultText=root.querySelector('#finder-result-text');
          if(resultTitle&&resultText){
            if(resultTitle.textContent.indexOf('Left AirPod')!==-1&&resultText.textContent.indexOf('A3047')!==-1){
              resultText.textContent=resultText.textContent.replace('A3047','A3048');
            }
            if(resultTitle.textContent.indexOf('Right AirPod')!==-1&&resultText.textContent.indexOf('A3048')!==-1){
              resultText.textContent=resultText.textContent.replace('A3048','A3047');
            }
          }
        }

        var tradeParts=root.querySelector('[data-ap-trade-part-choices]');
        if(tradeParts){
          var tradeLeft=tradeParts.querySelector('[data-ap-trade-part-key="left"]');
          var tradeRight=tradeParts.querySelector('[data-ap-trade-part-key="right"]');
          if(tradeLeft){
            tradeLeft.setAttribute('data-ap-trade-value','Left A2699 / A3048');
            var tl=tradeLeft.querySelector('span');if(tl){setText(tl,'A2699 / A3048');}
          }
          if(tradeRight){
            tradeRight.setAttribute('data-ap-trade-value','Right A2698 / A3047');
            var tr=tradeRight.querySelector('span');if(tr){setText(tr,'A2698 / A3047');}
          }
        }
      }
    }

    function findVariantByModel(model){
      var wanted=String(model||'').toLowerCase();
      return productVariants.find(function(variant){
        return normalise(variant.title).split(' ').indexOf(wanted)!==-1;
      });
    }

    function setFinderPartAvailability(button,model){
      if(!button){return;}
      var variant=findVariantByModel(model);
      if(variant&&variant.available){
        button.disabled=false;
        button.removeAttribute('aria-disabled');
        button.style.opacity='';
        var old=button.querySelector('[data-reset-finder-stock]');if(old){old.remove();}
      }else{
        button.disabled=true;
        button.setAttribute('aria-disabled','true');
        button.style.opacity='.48';
        var status=button.querySelector('[data-reset-finder-stock]');
        if(!status){status=document.createElement('span');status.setAttribute('data-reset-finder-stock','true');button.appendChild(status);}
        setText(status,'Sold out');
      }
    }

    function patchFinderAvailability(){
      patchFinderCopy();
      var name=finderSelectedName();
      var buttons=root.querySelectorAll('#finder-part-grid button');
      if(!buttons.length||!productVariants.length){return;}

      if(name.indexOf('pro 2nd generation usb c')!==-1||name.indexOf('pro 2nd generation usb')!==-1){
        setFinderPartAvailability(buttons[0],'a3048');
        setFinderPartAvailability(buttons[1],'a3047');
        setFinderPartAvailability(buttons[2],'a2968');
      }else if(name.indexOf('pro 2nd generation lightning')!==-1){
        setFinderPartAvailability(buttons[0],'a2699');
        setFinderPartAvailability(buttons[1],'a2698');
        setFinderPartAvailability(buttons[2],'a2700');
      }
    }

    function queuePatch(){
      if(patchQueued){return;}
      patchQueued=true;
      setTimeout(function(){
        patchQueued=false;
        patchFinderCopy();
        if(productVariants.length){patchFinderAvailability();}
      },0);
    }

    var style=document.createElement('style');
    style.textContent='.ap-page .ap-option.reset-sold-out,.ap-page .ap-option.reset-needs-version{opacity:.46;cursor:not-allowed;transform:none!important}.ap-page .ap-option [data-reset-stock-status]{color:#8b3f3f!important;font-weight:800!important}.ap-page .reset-all-sold-out{margin-top:12px;padding:12px 14px;border-radius:16px;background:#f7f7f8;color:#6e6e73;font-size:13px;line-height:1.4}.ap-page #finder-part-grid button:disabled{cursor:not-allowed;transform:none!important}';
    document.head.appendChild(style);

    patchStaticCopy();
    patchFinderCopy();

    var observer=new MutationObserver(queuePatch);
    observer.observe(root,{childList:true,subtree:true,characterData:true});

    var productJsonPath=window.location.pathname.replace(/\/$/,'')+'.js';
    fetch(productJsonPath,{headers:{Accept:'application/json'}})
      .then(function(response){if(!response.ok){throw new Error('Product data unavailable');}return response.json();})
      .then(function(product){
        productVariants=Array.isArray(product.variants)?product.variants:[];
        applyAvailability();
      })
      .catch(function(){
        patchFinderCopy();
      });
  });
})();
